import Constraints from "../../api/model/snapshots/layers/Constraints";

function equals(constraints: Constraints, otherConstraints: Constraints) {
    return (
        constraints.horizontal.max === otherConstraints.horizontal.max &&
        constraints.horizontal.min === otherConstraints.horizontal.min &&
        constraints.horizontal.sizingMode === otherConstraints.horizontal.sizingMode &&
        constraints.vertical.max === otherConstraints.vertical.max &&
        constraints.vertical.min === otherConstraints.vertical.min &&
        constraints.vertical.sizingMode === otherConstraints.vertical.sizingMode
    );
}

export { equals };
